(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/assets/javascripts/views/payment-prompt.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/assets/javascripts/views/payment-prompt.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

(function (Backbone, _, svs) {
  'use strict';

  svs.tur.start_subscription.views.PaymentPrompt = Marionette.View.extend({
    ui: {
      approveCheckbox: '#js-approve-checkbox',
      approveBtn: '.js-approve-ag',
      payWithAgBtn: '.js-pay-with-ag-button',
      payWithCardBtn: '.js-pay-with-card-button',
      registerBankaccountBtn: '.js-register-bankaccount',
      changeBankaccountBtn: '.js-change-bankaccount'
    },
    events: {
      'change @ui.approveCheckbox': 'toggleTermsApproved',
      'click @ui.approveBtn': 'approveBtnClicked',
      'click @ui.payWithAgBtn': 'payWithAgBtnClicked',
      'click @ui.payWithCardBtn': 'payWithCardBtnClicked',
      'click @ui.registerBankaccountBtn': 'registerBankaccountBtnClicked',
      'click @ui.changeBankaccountBtn': 'changeBankaccountBtnClicked'
    },
    regions: {
      paymentPromptRegion: '#paymentPromptRegion'
    },
    template() {
      return '<div id="paymentPromptRegion"></div>';
    },
    onRender() {
      this.showChildView('paymentPromptRegion', {
        _self: this,
        model: this.model,
        template(data) {
          return svs.tur.start_subscription.templates.payment_prompt(data);
        },
        templateContext() {
          if (!this.model.get('isBankcard') && !this.model.get('isAutogiro')) {
            this.model.set('isBankcard', true);
          }
          if (!this.model.get('entry')) {
            this.model.set('entry', this.model.get('cardEntry'));
            this.model.set('isBankcard', true);
          }
          const templateObject = {
            isBankcard: this.model.get('isBankcard'),
            hasActivePayChannel: this.model.get('hasActivePayChannel'),
            amount: svs.utils.format.Currency(this.model.get('entry').amount),
            startTime: svs.utils.date.FormatTime('d/M', this.model.get('entry').startTime),
            stopTime: svs.utils.date.FormatTime('d/M', this.model.get('entry').stopTime),
            weeklyCost: svs.utils.format.Currency(this.model.get('subscriptionOptions').weeklyCost),
            dayCost: svs.utils.format.Currency(parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10)),
            gameDaysStart: parseInt(this.model.get('entry').amount, 10) / parseInt(this.model.get('subscriptionEntry').wagers[0].wagerAmount, 10)
          };
          return templateObject;
        },
        onBeforeAttach() {
          svs.components.Modal.setHeaderOptions({
            title: 'Betala',
            contentClass: svs.core.detect.formfactor.mobile() ? 'bg-white' : '',
            doubleWidth: true,
            rightButton: {
              visible: false
            },
            leftButton: {
              text: 'Avbryt',
              visible: true,
              callback: () => {
                const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', this.options._self.options.context);
                if (swpCheckout && swpCheckout.cleanUpSwedbankPayTransaction && typeof swpCheckout.cleanUpSwedbankPayTransaction === 'function') {
                  this.options._self.options.context.triggerPrefixMethod('cancelButtonFirstPayBankcardSubscription');
                  swpCheckout.cleanUpSwedbankPayTransaction();
                }
                const subscriptionId = this.options._self.options.model.get('newSubId');
                subscriptionId && svs.tur.start_subscription.radio.request('cancelSubscription', subscriptionId, this, () => {});
                svs.components.Modal.hide();
              }
            }
          });
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        onAttach() {
          this.model.getAutogiroInfo();
          this.options.initDropdowns();
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        onRender() {
          svs.components.Modal && svs.components.Modal.currentView() && svs.components.Modal.currentView().trigger('modalContentResize');
        },
        initDropdowns() {
          const _self = this._self;
          const dropdownOptions = {
            el: 'js-dropdown-deposit',
            class: 'js-dropdown-deposit',
            clickCallback: function cb(item) {
              const clickedItem = item['data-item'];
              if (clickedItem === 'creditcard') {
                _self.model.set('isBankcard', true);
                _self.model.set('isAutogiro', false);
                _self.model.set('entry', _self.model.get('cardEntry'));
              } else {
                const swpCheckout = svs.tur.start_subscription.radio.request('getSwedbankPayCheckoutObject', _self.options.context);
                if (swpCheckout && swpCheckout.cleanUpSwedbankPayTransaction && typeof swpCheckout.cleanUpSwedbankPayTransaction === 'function') {
                  _self.options.context.triggerPrefixMethod('cancelDropdownFirstPayBankcardSubscription');
                  swpCheckout.cleanUpSwedbankPayTransaction();
                } else {
                  _self.options.context.triggerPrefixMethod('cancelDropdownBeforeFirstPayBankcardSubscription');
                }
                _self.model.set('isBankcard', false);
                _self.model.set('isAutogiro', true);
                _self.model.set('entry', _self.model.get('autogiroEntry'));
              }
              _self.render();
            }
          };
          new svs.ui.Dropdown(dropdownOptions);
        },
        initSwedbankPay() {
          const _self = this._self;
          const swpOptions = {
            context: _self
          };
          _self.swedbankPayCheckout = new svs.accountservices.swedbankpay_checkout.SwedbankPayCheckout(swpOptions);
        }
      });
    },
    autogiroClicked() {
      this.showConfirmPaymentMethod(this.model.get('autogiroEntry'), 'autogiro');
    },
    bankcardClicked() {
      this.showConfirmPaymentMethod(this.model.get('cardEntry'), 'kort');
    },
    showConfirmPaymentMethod(entry, paymentTypeText) {
      const {
        title,
        message
      } = this.getDialogConfirmPaymentMessage(_objectSpread(_objectSpread({}, entry), {}, {
        paymentTypeText
      }));
      const dialog = new svs.ui.dialog.Confirm({
        branding: svs.ui.dialog.branding.TUR,
        icon: 'subscription',
        title,
        message,
        actions: [{
          title: 'Avbryt'
        }, {
          title: 'Starta',
          callback: () => {
            dialog.close(() => {
              this.model.set('entry', entry);
              svs.components.Modal.hide();
              this.options.context.triggerPrefixMethod('paymentTypeChosen');
            });
          }
        }]
      });
      svs.ui.dialog.api.add(dialog);
    },
    getDialogConfirmPaymentMessage(_ref) {
      let {
        isAutogiro,
        isBankcard,
        startTime,
        stopTime,
        amount,
        paymentTypeText
      } = _ref;
      const weeklyCost = this.model.get('subscriptionOptions').weeklyCost;
      startTime = svs.utils.date.FormatTime('d/M', startTime);
      stopTime = svs.utils.date.FormatTime('d/M', stopTime);
      amount = svs.utils.format.Currency(amount);
      return {
        title: "Prenumeration med ".concat(paymentTypeText),
        message: [{
          type: svs.ui.dialog.message.TEXT,
          text: "Prenumerationen kostar ".concat(weeklyCost, " kr/vecka. <br/>") + "F\xF6r startperioden ".concat(startTime, " - ").concat(stopTime, " \xE4r totala kostnaden ").concat(amount, " kr") + "".concat(isBankcard ? ' och debiteras ditt bankkort direkt' : '', ".<br/>") + "".concat(isAutogiro ? "Detta belopp dras prelimin\xE4rt den ".concat(startTime, " f\xF6rutsatt att ditt autogiromedgivande blir godk\xE4nt.") : '')
        }]
      };
    },
    showChoosePayment() {
      this.showChildView('paymentPromptRegion', this.choosePaymentView);
    },
    showBankCardInfo() {
      this.changeView('Bankkort', svs.tur.start_subscription.templates.creditcard);
    },
    showAutogiroInfo() {
      this.changeView('Autogiro', svs.tur.start_subscription.templates.bankgiro);
    },
    changeView(title, template) {
      this.choosePaymentView = this.detachChildView('paymentPromptRegion');
      svs.components.Modal.setHeaderOptions({
        title,
        doubleWidth: true,
        leftButton: {
          visible: false
        },
        rightButton: {
          text: 'Tilbaka',
          visible: true,
          callback: function () {
            this.showChoosePayment();
          }.bind(this)
        }
      });
      this.showChildView('paymentPromptRegion', {
        template() {
          return template();
        }
      });
    },
    onDestroy() {
      this.choosePaymentView && this.choosePaymentView.destroy();
    },
    toggleTermsApproved() {
      $('.js-approve-ag').attr('disabled', !$('#js-approve-checkbox')[0].checked);
    },
    approveBtnClicked() {
      this.options.context.createDirectDebitPermission();
    },
    payWithAgBtnClicked() {
      this.options.context.triggerPrefixMethod('paymentTypeChosen');
    },
    payWithCardBtnClicked() {
      this.options.context.triggerPrefixMethod('paymentTypeChosen');
    },
    registerBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalRegisterBankAccount'), {
        returnUrl: window.location
      });
      return false;
    },
    changeBankaccountBtnClicked() {
      svs.utils.form.postToUrl(svs.core.urlMapping.get('transactionsWithdrawalChangeBankAccount'), {
        returnUrl: window.location
      });
      return false;
    }
  });
})(Backbone, _, svs);

 })(window);